import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const buildAuthPayload = (extra = {}) => {
  const auth = store.getState().auth;
  return {
    auth_key: auth.user.auth_key,
    salon_id: auth.user.salon_id,
    ...extra,
  };
};

const fetchActive = () => {
  const action = "afterlogin/feature-announcements/active";
  return axios.post(API_URL + action, buildAuthPayload({ action }), {
    headers: authHeader(),
  });
};

const FeatureAnnouncementService = {
  fetchActive,
};

export default FeatureAnnouncementService;
